export const checkItem = (e: any) => {
	if (
		!e.target.parentElement.parentElement.parentElement.className
			.replaceAll("--selected", "")
			.includes("--complete")
	) {
		e.target.parentElement.parentElement.parentElement.className =
			e.target.parentElement.parentElement.parentElement.className.replaceAll(
				"--selected",
				""
			) + "--complete";
		return e.target.parentElement.parentElement.parentElement.className;
	}
	const newClass = e.target.parentElement.parentElement.parentElement.className
		.replaceAll("--selected", "")
		.replace("--complete", "");
	e.target.parentElement.parentElement.parentElement.className = newClass;
	return e.target.parentElement.parentElement.parentElement.className;
};
